<template>
  <div class="card m-4">

    <div class="grid grid-cols-6 gap-4">

      <div class="col-span-6">

        <div class="card">
          <Toolbar class="mb-4">
            <template #start>
              <Button label="Agregar" icon="pi pi-plus" class="p-button-success mr-2" @click="addBusiness" />
            </template>

            <template #end>
              <Button label="Exportar" icon="pi pi-upload" class="p-button-help" @click="exportCSV($event)" />
            </template>
          </Toolbar>

          <DataTable ref="dt" :value="business" v-model:selection="selectedBusiness" dataKey="id"
                     :scrollable="true" scrollHeight="400px" filterDisplay="menu"
                     :paginator="true" :rows="10" v-model:filters="filters" :rowsPerPageOptions="[5,10,25]" scrollDirection="both" showGridlines
                     paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                     currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords}" class="p-datatable-sm" :rowClass="rowClass">
            <template #header>
              <div class="flex items-center flex-col md:justify-between md:flex-row">
                <h5 class="mb-2 md:m-0 p-as-md-center">Empresas</h5>
                <span class="p-input-icon-left">
                  <i class="pi pi-search" />
                  <InputText v-model="filters['global'].value" placeholder="Buscar..." />
                </span>
              </div>
            </template>
            <Column field="periodoFacturado" header="Utl.Fact." :sortable="true" style="min-width:12rem">
              <template #body="{data}">
                {{data.periodoFacturado}}
              </template>
              <template #filter="{filterModel}">
                <InputText type="text" v-model="filterModel.value" placeholder="Buscar por ..." />
              </template>
            </Column>
            <Column field="cuit" header="Cuit" :sortable="true" style="min-width:12rem"></Column>
            <Column field="nombre" header="Nombre" :sortable="true" style="min-width:30rem">
              <template #body="{data}">
                {{data.nombre}}
              </template>
              <template #filter="{filterModel}">
                <InputText type="text" v-model="filterModel.value" placeholder="Buscar por ..." />
              </template>
            </Column>
            <Column field="cuotaFija" header="Cuota" :sortable="true" style="min-width:8rem">
              <template #body="slotProps">
                {{formatCurrency(slotProps.data.cuotaFija)}}
              </template>
            </Column>
            <Column field="valorFijo" header="Valor Fijo" dataType="boolean" :sortable="true" style="min-width:8rem">
              <template #body="{data}">
                <i class="pi" :class="{'true-icon pi-check-circle': data.valorFijo, 'false-icon pi-times-circle': !data.valorFijo}"></i>
              </template>
            </Column>
            <Column field="contratados" header="Contra." dataType="boolean" :sortable="true" style="min-width:8rem">
              <template #body="{data}">
                <i class="pi" :class="{'true-icon pi-check-circle': data.contratados, 'false-icon pi-times-circle': !data.contratados}"></i>
              </template>
            </Column>
            <Column field="titulares" header="Titul." :sortable="true" style="min-width:8rem"></Column>
            <Column field="beneficiarios" header="Benef." :sortable="true" style="min-width:8rem"></Column>
            <Column field="anulado" header="Anul." dataType="boolean" :sortable="true" style="min-width:8rem">
              <template #body="{data}">
                <i class="pi" :class="{'true-icon pi-check-circle': data.anulado, 'false-icon pi-times-circle': !data.anulado}"></i>
              </template>
              <template #filter={filterModel,filterCallback}>
                <Dropdown v-model="filterModel.value" :options="status" optionLabel="name" optionValue="value" placeholder="Estado" @change="filterCallback()" />
              </template>
            </Column>
            <Column header="Acciones" :exportable="false" style="min-width:8rem" frozen alignFrozen="right">
              <template #body="slotProps">
                <div class="grid grid-cols-6 gap-2">
                  <div class="col-span-6 sm:col-span-2">
                    <Button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2 p-button-sm" @click="editBusiness(slotProps.data)" v-tooltip="'Editar empresa'" />
                  </div>
                  <div class="col-span-6 sm:col-span-2">
                    <Button icon="pi pi-users" class="p-button-rounded p-button-success mr-2 p-button-sm" @click="editAfiliados(slotProps.data)" v-tooltip="'Editar afiliados'" />
                  </div>
                  <div class="col-span-6 sm:col-span-2">
                    <Button v-if="slotProps.data.anulado" icon="pi pi-undo" class="p-button-rounded p-button-warning p-button-sm" @click="deleteBusiness(slotProps.data)" />
                    <Button v-else icon="pi pi-trash" class="p-button-rounded p-button-warning p-button-sm" @click="deleteBusiness(slotProps.data)" />
                  </div>
                </div>
              </template>
            </Column>
            <template #paginatorstart>
              <Button type="button" icon="pi pi-refresh" class="p-button-text p-button-sm" @click="initLoad" />
            </template>
            <template #paginatorend>
              <Button type="button" icon="pi pi-filter-slash" label="Limpiar" class="p-button-outlined p-button-sm" @click="clearFilter()" />
            </template>
          </DataTable>
        </div>

      </div>

    </div>

    <Dialog header="Empresa" v-model:visible="displayBusiness" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '50vw'}" :maximizable="true" :modal="true">
      <EmpresaEdit @closeModal="closeModal" :info="bus"></EmpresaEdit>
    </Dialog>

    <Dialog header="Afiliados" v-model:visible="displayAfiliados" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '50vw'}" :maximizable="true" :modal="true">
      <EmpresaAfi @closeModal="closeAfi" :info="afi"></EmpresaAfi>
    </Dialog>

  </div>
</template>

<script>
  import { ref, onMounted } from 'vue';
  import WService from '@/plugins/ws';
  import { FilterMatchMode, FilterOperator } from 'primevue/api';
  import Tooltip from 'primevue/tooltip';
  import DataTable from 'primevue/datatable';
  import Toolbar from 'primevue/toolbar';
  import Column from 'primevue/column';
  import ColumnGroup from 'primevue/columngroup';
  import Row from 'primevue/row';
  import Button from 'primevue/button';
  import InputText from 'primevue/inputtext';
  import Dropdown from 'primevue/dropdown';
  import Dialog from 'primevue/dialog';
  import EmpresaEdit from './empresaEdit.vue';
  import EmpresaAfi from './empresaAfi.vue';

  export default {
    components: {
      DataTable, Toolbar, Column, ColumnGroup, Row, Button, InputText, Dropdown,
      Dialog, EmpresaEdit, EmpresaAfi
    },
    setup() {
      onMounted(() => {
        initLoad();
      })

      const wService = ref(new WService());
      const dt = ref();
      const business = ref();
      const bus = ref(null);
      const afi = ref({
        empresa: '',
        id: 0
      });
      const selectedBusiness = ref();
      const displayBusiness = ref(false);
      const displayAfiliados = ref(false);
      const filters = ref({
        'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
        'periodoFacturado': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        'nombre': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        'anulado': { value: false, matchMode: FilterMatchMode.EQUALS }
      });
      const status = ref([
        { name: 'Anulado', value: true },
        { name: 'Sin Anular', value: false },
        { name: 'Todos', value: null },
      ]);

      const addBusiness = () => {
        bus.value = null;
        displayBusiness.value = true;
      };

      const editAfiliados = (info) => {
        afi.value.empresa = info.nombre;
        afi.value.id = info.idEmpresa;
        displayAfiliados.value = true;
      };

      const editBusiness = (info) => {
        bus.value = info;
        displayBusiness.value = true;
      };

      const deleteBusiness = () => {

      };

      const closeModal = (res) => {
        displayBusiness.value = false;
      };

      const closeAfi = (res) => {
        displayAfiliados.value = false;
      };

      const initLoad = () => {
        wService.value.getMethod('Empresas/CtaCte').then(data => business.value = data);
      }

      const clearFilter = () => {
        filters.value = {
          'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
          'periodoFacturado': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
          'nombre': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
          'anulado': { value: null, matchMode: FilterMatchMode.EQUALS }
        }
      };

      const rowClass = (data) => {
        return data.anulado ? 'row-deleted' : null;
      };

      const formatCurrency = (value) => {
        if (value)
          return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
        return;
      };

      const exportCSV = () => {
        dt.value.exportCSV();
      };

      return {
        dt, business, bus, filters, selectedBusiness, status, displayBusiness, displayAfiliados,
        afi,

        initLoad, addBusiness, editBusiness, rowClass, formatCurrency, exportCSV, clearFilter, closeModal,
        editAfiliados, closeAfi, 
      };
    },
    directives: {
      'tooltip': Tooltip
    }
  }
</script>
<style>
  .row-deleted {
    background-color: rgba(255,0,0,.15) !important;
  }
</style>